// Entry point for the build script in your package.json

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

import "./features/clickToShow";
import "./features/scheduleDates";
import "./features/featherlight";
